import { useTranslation } from 'react-i18next';
import { ChargeCode } from 'graphql-query-contracts';
import { useChannelAdminContext } from 'hooks';
import { useHistory, generatePath } from 'react-router-dom';
import { routes } from 'lane-shared/config';

export interface chargeCodeAction {
  label: string;
  onSelect: Function;
}

type ChargeCodesActionsProps = {
  onDelete: (chargeCode: ChargeCode) => void;
};

export function useGetActionsForChargeCodes({
  onDelete,
}: ChargeCodesActionsProps): chargeCodeAction[] {
  const { t } = useTranslation();
  const history = useHistory();
  const { channel } = useChannelAdminContext();
  const channel_slug = channel?.slug || '';

  const editChargeCodeAction = (chargeCode: ChargeCode) => {
    history.push(
      generatePath(routes.channelAdminEditChargeCodeForm, {
        id: channel_slug,
        chargeCodeId: chargeCode.id,
      })
    );
  };

  const deleteChargeCodeAction = (chargeCode: ChargeCode) => {
    onDelete(chargeCode);
  };

  const actions = [
    {
      label: t('web.admin.content.sections.table.edit'),
      onSelect: (chargeCode: ChargeCode) => editChargeCodeAction(chargeCode),
    },
    {
      label: t('web.admin.content.sections.edit.delete'),
      onSelect: (chargeCode: ChargeCode) => deleteChargeCodeAction(chargeCode),
    },
  ];

  return actions;
}
